import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any; 

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent implements OnInit {

  bannerrequest: any = {};
  bannerList: any = "";
  videorequest: any = {
	pagesize: 6,
	page: 1,
	video_catagory_id: 1
  };
  videoList: any = "";
  videoList_last_page: boolean;

  constructor(private allpagesService: AllPageService,) { this.loadvideo(); }

  ngOnInit() {
    this.loadBanner();
	this.loadvideo();

    jQuery(".latest-video-box").slice(0, 12).show();
	  jQuery("#loadMore").on("click", function(e){
	    e.preventDefault();
	    jQuery(".latest-video-box:hidden").slice(0, 12).slideDown();
	    if(jQuery(".latest-video-box:hidden").length == 0) {
	      jQuery("#loadMore").text("No Content").addClass("noContent");
	    }
	});
	jQuery('.popup-youtube').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
	
		fixedContentPos: false
	});
  }

  loadBanner() {
		this.bannerrequest = {
			title : 'Videos'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			console.log(this.bannerList);
		});
	}

	getMoreVideos() {
		this.videorequest.page = this.videorequest.page + 1;
		this.loadvideo(true);
		
	  }

	loadvideo(concat:boolean = false) {
		let request = Object.assign({}, this.videorequest);
		this.allpagesService.getVideoListing(request).then((data: any) => {
			//this.videoList = data;
			if(data.data.length > 0)
       		{	
				if (concat) {
					this.videoList = this.videoList.concat(data.data);
				}else{
					this.videoList = data.data;
				}
			}else{
				this.videoList_last_page = true;

			}
			console.warn(this.videoList);

			setTimeout(() => {
				jQuery('.popup-youtube').magnificPopup({
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
				
					fixedContentPos: false
				});
			}, 1000);
		});
	}

}
